<template>
  <section v-if="!useV2026MessageTemplateSettings" class="p-3 mb-5">
    <h4>ตอบด้วยคีย์ลัด</h4>

    <div class="row py-2">
      <div class="col-6">
        <router-link :to="{name: 'message-template-category'}" class="btn btn-primary">จัดการหมวดหมู่คีย์ลัด</router-link>
      </div>
      <div class="col-6">
        <form @submit.prevent="loadFirstMessageTemplates(queryParams.customer_type)">
          <div class="row justify-content-end">
            <div class="col-md-6 col-12">
              <div class="form-group">
                <input type="search" class="form-control" placeholder="ค้นหา"  v-model="queryParams.keyword">
              </div>
            </div>
            <div class="col-md-2 col-12">
              <div class="form-group">
                <button class="btn btn-primary" type="submit">ค้นหา</button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="pt-3">
      <b-nav tabs justified>
        <b-nav-item :active="queryParams.customer_type === 'customer'"
                    @click="loadFirstMessageTemplates('customer')">
          <i class="fas fa-user"></i>&nbsp;&nbsp;คีย์ลัดฝั่งคุณลูกค้า
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type.includes('professional', 'professional_secondary')"
                    @click="loadFirstMessageTemplates('professional')">
          <i class="fas fa-id-badge"></i>&nbsp;&nbsp;คีย์ลัดฝั่งผู้สมัคร
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'beneat_professional'"
                    @click="loadFirstMessageTemplates('beneat_professional')">
          <i class="fas fa-female"></i>&nbsp;&nbsp;คีย์ลัดฝั่งคุณแม่บ้าน
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'sales_product_customer'"
                    @click="loadFirstMessageTemplates('sales_product_customer')">
          <i class="fas fa-user-circle"></i>&nbsp;&nbsp;คีย์ลัดฝั่งคุณลูกค้า (Sales)
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'recruitment_customer'"
                    @click="loadFirstMessageTemplates('recruitment_customer')">
          <i class="fas fa-user"></i>&nbsp;&nbsp;คีย์ลัดฝั่งคุณลูกค้า (Recruit)
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'recruitment_professional'"
                    @click="loadFirstMessageTemplates('recruitment_professional')">
          <i class="fas fa-female"></i>&nbsp;&nbsp;คีย์ลัดฝั่งคุณแม่บ้าน (Recruit)
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'mari_customer'"
                    @click="loadFirstMessageTemplates('mari_customer')">
          <i class="fas fa-user"></i>&nbsp;&nbsp;คีย์ลัดฝั่งคุณลูกค้า (Mari)
        </b-nav-item>
        <b-nav-item :active="queryParams.customer_type === 'mari_professional'"
                    @click="loadFirstMessageTemplates('mari_professional')">
          <i class="far fa-id-badge"></i>&nbsp;&nbsp;คีย์ลัดฝั่งผู้สมัคร (Mari)
        </b-nav-item>
      </b-nav>
    </div>
    <section class="my-3">
      <div class="card mb-2">
        <div class="card-body px-1 py-2">
          <div class="row text-center">
            <div class="col-lg-1 col-md-2 border-right">
              <span class="border-dark">Shortcut</span>
            </div>

            <div class="col-md-2  border-right">
              <span class="border-dark">หมวดหมู่</span>
            </div>

            <div class="col-md-2  border-right">
              <span class="border-dark">Topic</span>
            </div>

            <div class="col-lg-6 col-md-4">
              <span class="border-dark"> เนื้อหา </span>
            </div>
          </div>
        </div>
      </div>

      <div v-for="(messageTemplate) in manageMessageTemplates" :key="messageTemplate.id">
        <message-template-item :messageTemplate="messageTemplate"></message-template-item>
      </div>
      <div class="row">
        <div class="col-md-6">
          <span class="text-muted">แสดงหน้า {{ queryParams.page }} จาก {{ pageCount }}</span>
        </div>
        <div class="col-md-6 d-flex flex-row-reverse">
          <paginate
            v-model="queryParams.page"
            :page-count="pageCount"
            :page-range="5"
            :margin-pages="2"
            :click-handler="clickPaginate"
            :prev-text="'Previous'"
            :next-text="'Next'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :active-class="'active'"
            :disabled-class="'disabled'"
            :prev-class="'page-item'"
            :prev-link-class="'page-link'"
            :next-class="'page-item'"
            :next-link-class="'page-link'"
          >
          </paginate>
        </div>
      </div>
    </section>
  </section>

  <section v-else class="v2026-mt" :class="'is-w-' + layout">
    <h4 class="v2026-mt-title">ตอบด้วยคีย์ลัด</h4>

    <div class="v2026-mt-toolbar">
      <RouterLink :to="{ name: 'message-template-category' }" class="v2026-mt-btn-primary">
        จัดการหมวดหมู่คีย์ลัด
      </RouterLink>

      <form class="v2026-mt-search"
            @submit.prevent="loadFirstMessageTemplates(queryParams.customer_type)">
        <div class="v2026-mt-field">
          <span class="v2026-mt-field__ico" aria-hidden="true"></span>
          <input type="text"
                 class="v2026-mt-field__input"
                 placeholder="ค้นหา"
                 aria-label="ค้นหาคีย์ลัด"
                 v-model="queryParams.keyword">
          <!-- type="button" and assign '' ONLY: inside a form a bare button submits, and calling
               loadFirst* here would fetch twice. The keyword watcher does the single reload. -->
          <button v-if="queryParams.keyword"
                  type="button"
                  class="v2026-mt-field__clear"
                  aria-label="ล้างคำค้นหา"
                  @click="queryParams.keyword = ''">×</button>
        </div>
        <button type="submit" class="v2026-mt-btn-ghost">ค้นหา</button>
        <LoadingV2026 v-if="isLoading" label="กำลังโหลด"/>
      </form>
    </div>

    <SettingsTabsV2026 :tabs="mtTabs"
                       :activeType="queryParams.customer_type"
                       ariaLabel="ประเภทคีย์ลัด"
                       idPrefix="v2026-stab-mt-"
                       panelId="v2026-mt-panel"
                       @select="loadFirstMessageTemplates"/>

    <div id="v2026-mt-panel"
         ref="mtList"
         class="v2026-mt-list"
         :class="'is-w-' + layout"
         role="tabpanel"
         :aria-labelledby="'v2026-stab-mt-' + queryParams.customer_type"
         :aria-busy="isLoading ? 'true' : 'false'">
      <div v-if="!emptyState" class="v2026-mt-head" aria-hidden="true">
        <span>Shortcut</span>
        <span>หมวดหมู่</span>
        <span v-if="layout === 'lg'">Topic</span>
        <span>เนื้อหา</span>
        <span></span>
      </div>

      <MessageTemplateItemV2026 v-for="messageTemplate in rows"
                                :key="messageTemplate.id"
                                :messageTemplate="messageTemplate"
                                :layout="layout"
                                @preview="openPreview"
                                @notify="onNotify"/>

      <div v-if="emptyState === 'no-result'" class="v2026-mt-empty" role="status">
        <span class="v2026-mt-empty__ico v2026-mt-empty__ico--search" aria-hidden="true"></span>
        <div class="v2026-mt-empty__title">ไม่พบคีย์ลัดที่ตรงกับ “{{ emptyKeyword }}”</div>
        <div class="v2026-mt-empty__msg">ลองใช้คำอื่น หรือล้างคำค้นหาเพื่อดูคีย์ลัดทั้งหมด</div>
        <button type="button"
                class="v2026-mt-btn-ghost v2026-mt-empty__act"
                @click="queryParams.keyword = ''">ล้างคำค้นหา</button>
      </div>

      <div v-else-if="emptyState === 'no-data'" class="v2026-mt-empty" role="status">
        <span class="v2026-mt-empty__ico v2026-mt-empty__ico--keyboard" aria-hidden="true"></span>
        <div class="v2026-mt-empty__title">ยังไม่มีคีย์ลัดในกลุ่มนี้</div>
        <div class="v2026-mt-empty__msg">เลือกกลุ่มอื่นจากแท็บด้านบนเพื่อดูคีย์ลัดที่มีอยู่</div>
      </div>
    </div>

    <div v-if="hasRows" class="v2026-mt-pager">
      <span class="v2026-mt-pager__count">แสดงหน้า {{ queryParams.page }} จาก {{ pageCount }}</span>

      <nav class="v2026-mt-pages" aria-label="เปลี่ยนหน้า">
        <button type="button"
                class="v2026-mt-page v2026-mt-page--prev"
                aria-label="หน้าก่อนหน้า"
                :disabled="queryParams.page <= 1"
                @click="clickPaginate(queryParams.page - 1)">
          <span class="v2026-mt-page__ico" aria-hidden="true"></span>
        </button>

        <template v-for="(p, i) in pageItems">
          <span v-if="p === '…'" :key="'e' + i" class="v2026-mt-ellipsis" aria-hidden="true">…</span>
          <!-- clickPaginate takes the SAME 1-based number vuejs-paginate emitted; the 0-based
               translation stays where it has always been: params.page = params.page - 1. -->
          <button v-else
                  :key="p"
                  type="button"
                  class="v2026-mt-page"
                  :class="{ 'is-current': p === queryParams.page }"
                  :aria-current="p === queryParams.page ? 'page' : null"
                  :aria-label="'หน้า ' + p"
                  @click="clickPaginate(p)">{{ p }}</button>
        </template>

        <button type="button"
                class="v2026-mt-page v2026-mt-page--next"
                aria-label="หน้าถัดไป"
                :disabled="queryParams.page >= pageCount"
                @click="clickPaginate(queryParams.page + 1)">
          <span class="v2026-mt-page__ico" aria-hidden="true"></span>
        </button>
      </nav>
    </div>

    <BaseModal :open="preview.open" maxWidth="900px" @close="preview.open = false">
      <div class="v2026-mt-preview" role="dialog" aria-modal="true" aria-label="ดูรูปขนาดเต็ม">
        <img :src="preview.url" alt="">
      </div>
    </BaseModal>

    <BaseToast :open="toast.open"
               :variant="toast.variant"
               :title="toast.title"
               :message="toast.message"
               @close="toast.open = false"/>
  </section>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import MessageTemplateItem from '../components/messageTemplate/MessageTemplateItem'
import MessageTemplateItemV2026 from '../components/messageTemplate/MessageTemplateItemV2026'
import SettingsTabsV2026 from '../components/settings/SettingsTabsV2026'
import { MT_TABS } from '../constants/settingsTabs'
import BaseModal from '../components/coversation/BaseModal'
import BaseToast from '../components/coversation/BaseToast'
import LoadingV2026 from '../components/coversation/LoadingV2026'

export default {
  components: {
    MessageTemplateItem,
    MessageTemplateItemV2026,
    SettingsTabsV2026,
    BaseModal,
    BaseToast,
    LoadingV2026
  },
  data () {
    return {
      queryParams: {
        page: 1,
        keyword: '',
        limit: 20,
        customer_type: 'customer',
        categories: []
      },
      pageCount: 1,
      // version2026: FALSE restores today's bootstrap page verbatim — the b-nav tabs (including the
      // two-tabs-lit includes() quirk), the .card fake table with MessageTemplateItem rows,
      // <paginate>, and the $swal 404 dialog. Flipping this boolean is the entire rollback.
      useV2026MessageTemplateSettings: true,
      layout: 'lg',
      emptyState: null,
      emptyKeyword: '',
      isLoading: false,
      toast: {
        open: false,
        variant: 'success',
        title: '',
        message: ''
      },
      preview: {
        open: false,
        url: ''
      }
    }
  },
  watch: {
    'queryParams.keyword': function (newVal, oldVal) {
      if (!newVal && oldVal) {
        this.loadFirstMessageTemplates(this.queryParams.customer_type)
      }
    }
  },
  computed: {
    ...mapState({
      manageMessageTemplates: state => state.messageTemplate.manageMessageTemplates,
      canLoadMore: state => state.messageTemplate.canLoadMore,
      categories: state => state.messageTemplate.categories
    }),
    mtTabs () {
      return MT_TABS
    },
    // Clearing the previous tab's rows without touching the store: an empty state renders no rows.
    rows () {
      return this.emptyState ? [] : (this.manageMessageTemplates || [])
    },
    hasRows () {
      return this.rows.length > 0
    },
    pageItems () {
      const total = this.pageCount
      const cur = this.queryParams.page
      if (total <= 7) {
        const a = []
        for (let i = 1; i <= total; i++) a.push(i)
        return a
      }
      let start = Math.max(2, cur - 2)
      let end = Math.min(total - 1, cur + 2)
      if (cur <= 4) {
        start = 2
        end = 5
      }
      if (cur >= total - 3) {
        start = total - 4
        end = total - 1
      }
      const out = [1]
      if (start > 2) out.push('…')
      for (let i = start; i <= end; i++) out.push(i)
      if (end < total - 1) out.push('…')
      out.push(total)
      return out
    }
  },
  methods: {
    ...mapActions('messageTemplate', ['fetchMessageTemplates', 'fetchCategories']),
    async clickPaginate (page) {
      this.queryParams.page = page
      await this.loadMessageTemplates()
    },
    async loadMessageTemplates (customerType = null) {
      let params = { ...this.queryParams }
      params.page = params.page - 1
      params.customer_type = customerType || params.customer_type
      params.fetch_from_settings = 1
      const requestedKeyword = params.keyword
      this.isLoading = true
      this.fetchMessageTemplates(params).then(res => {
        this.pageCount = res.page_count || 1
        if (this.useV2026MessageTemplateSettings) {
          this.emptyState = null
        }
      }).catch(err => {
        if (this.useV2026MessageTemplateSettings) {
          this.handleLoadError(err, requestedKeyword)
          return
        }
        this.$swal({
          text: 'ผิดพลาด ' + err.message,
          type: 'error'
        })
      }).finally(() => {
        this.isLoading = false
      })
    },
    async loadFirstMessageTemplates (customerType) {
      this.queryParams.customer_type = customerType
      this.queryParams.page = 1
      await this.loadMessageTemplates()
    },
    // 404 is how this API says "no rows", for both a no-match search and an empty customer type.
    // The store's other reject path hands back a non-Error, which is also an empty result.
    handleLoadError (err, requestedKeyword) {
      const status = (err && err.response && err.response.status) || null
      const isEmpty = status === 404 || !(err instanceof Error)
      if (isEmpty) {
        this.emptyKeyword = requestedKeyword
        this.emptyState = requestedKeyword ? 'no-result' : 'no-data'
        this.pageCount = 1
        return
      }
      this.showToast('danger', 'โหลดคีย์ลัดไม่สำเร็จ', (err && err.message) || 'เกิดข้อผิดพลาด')
    },
    showToast (variant, title, message) {
      this.toast = { open: true, variant, title, message }
    },
    onNotify (payload) {
      this.showToast(payload.variant, payload.title, payload.message)
    },
    openPreview (url) {
      this.preview = { open: true, url }
    },
    // The tier is measured from the LIST ELEMENT, never the viewport: under /settings the menu
    // auto-collapses below 992px, so the page is WIDER at 900px than at 1024px.
    measureLayout () {
      const el = this.$refs.mtList
      if (!el) return
      const w = el.clientWidth
      this.layout = w >= 1040 ? 'lg' : (w >= 640 ? 'md' : 'sm')
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadFirstMessageTemplates('customer')
    })
    this.fetchCategories()
    if (this.useV2026MessageTemplateSettings) {
      this.$nextTick(this.measureLayout)
      if (typeof ResizeObserver !== 'undefined') {
        this.$nextTick(() => {
          if (!this.$refs.mtList) return
          this._ro = new ResizeObserver(this.measureLayout)
          this._ro.observe(this.$refs.mtList)
        })
      }
      window.addEventListener('resize', this.measureLayout)
    }
  },
  beforeDestroy () {
    if (this._ro) {
      this._ro.disconnect()
      this._ro = null
    }
    window.removeEventListener('resize', this.measureLayout)
  }
}
</script>

<style lang="scss" scoped>
/* Only the ten --v2026-color-* tokens declared on .v2026-shell resolve under /settings.
   --v2026-surface / --v2026-border / --v2026-icon / --v2026-r-tab do NOT exist here. */
.v2026-mt {
  padding: 16px 16px 48px;
  background: #ffffff;
}

.v2026-mt-title {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 600;
  color: #212529;
}

.v2026-mt-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin: 12px 0 8px;
}

.v2026-mt-search {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;

  .is-w-sm & {
    margin-left: 0;
    width: 100%;
  }
}

.v2026-mt-field {
  position: relative;
  width: 280px;
  max-width: 100%;

  .is-w-sm & {
    flex: 1 1 auto;
    width: auto;
  }
}

.v2026-mt-field__input {
  width: 100%;
  height: 36px;
  padding: 0 34px;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
  color: #212529;

  &::placeholder { color: #66696C; }
  &:focus {
    outline: none;
    border-color: var(--v2026-color-main);
    box-shadow: 0 0 0 3px rgba(49, 193, 215, .30);
  }
}

.v2026-mt-field__ico {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 16px;
  height: 16px;
  pointer-events: none;
  background-color: var(--v2026-color-icon-idle);
  -webkit-mask: url('~@/assets/icons2026/search.svg') center / contain no-repeat;
          mask: url('~@/assets/icons2026/search.svg') center / contain no-repeat;
}

.v2026-mt-field__clear {
  position: absolute;
  right: 6px;
  top: 6px;
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 6px;
  background: none;
  font-size: 16px;
  line-height: 1;
  color: #66696C;
  cursor: pointer;

  &:hover { background: var(--v2026-color-hover-bg); color: #212529; }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
}

.v2026-mt-btn-primary {
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  background: var(--v2026-color-main);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  &:hover, &:focus { color: #ffffff; text-decoration: none; }
  &:hover { filter: brightness(.94); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
}

.v2026-mt-btn-ghost {
  height: 36px;
  padding: 0 14px;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  font-size: 14px;
  color: #212529;
  cursor: pointer;
  white-space: nowrap;

  &:hover { background: var(--v2026-color-hover-bg); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
}

/* NO overflow declaration: .v2026-settings-content must stay the only vertical scroller and
   vue-lazyload's resolved scroll parent for every v-lazy thumbnail. */
.v2026-mt-list {
  --mt-cols: 112px 150px 170px minmax(0, 1fr) 132px;
  border-top: 1px solid #e9ecef;

  &.is-w-md { --mt-cols: 108px 150px minmax(0, 1fr) 104px; }
}

.v2026-mt-head {
  position: sticky;
  top: 0;
  z-index: 2;
  display: grid;
  grid-template-columns: var(--mt-cols);
  column-gap: 16px;
  align-items: center;
  height: 40px;
  padding: 0 8px;
  background: #ffffff;
  border-bottom: 1px solid #e9ecef;
  font-size: 12px;
  font-weight: 600;
  color: #66696C;

  .is-w-md & { column-gap: 12px; }
  .is-w-sm & { display: none; }
}

.v2026-mt-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 56px 16px;
}

.v2026-mt-empty__ico {
  width: 40px;
  height: 40px;
  background-color: #66696C;
  opacity: .55;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
}

.v2026-mt-empty__ico--search {
  -webkit-mask-image: url('~@/assets/icons2026/search.svg');
          mask-image: url('~@/assets/icons2026/search.svg');
}

.v2026-mt-empty__ico--keyboard {
  -webkit-mask-image: url('~@/assets/icons2026/keyboard.svg');
          mask-image: url('~@/assets/icons2026/keyboard.svg');
}

.v2026-mt-empty__title {
  font-size: 15px;
  font-weight: 600;
  color: #212529;
}

.v2026-mt-empty__msg {
  font-size: 13px;
  color: #66696C;
  max-width: 420px;
}

.v2026-mt-empty__act { margin-top: 8px; }

.v2026-mt-pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.v2026-mt-pager__count {
  font-size: 13px;
  color: #66696C;
}

.v2026-mt-pages {
  display: flex;
  align-items: center;
  gap: 4px;
}

.v2026-mt-page {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #E4E7EC;
  border-radius: 8px;
  background: #ffffff;
  font-size: 13px;
  color: #343a40;
  cursor: pointer;

  &:hover:not(:disabled):not(.is-current) { background: var(--v2026-color-hover-bg); }
  &:focus-visible { outline: none; box-shadow: 0 0 0 3px rgba(49, 193, 215, .30); }
  &:disabled { opacity: .4; cursor: default; }

  &.is-current {
    background: var(--v2026-color-main-soft);
    border-color: var(--v2026-color-main);
    color: var(--v2026-color-main-icon);
    font-weight: 600;
  }
}

.v2026-mt-page--prev,
.v2026-mt-page--next {
  padding: 0;
  width: 32px;
}

.v2026-mt-page__ico {
  display: inline-block;
  width: 16px;
  height: 16px;
  background-color: var(--v2026-color-icon-idle);
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
}

.v2026-mt-page--prev .v2026-mt-page__ico {
  -webkit-mask-image: url('~@/assets/icons2026/chevron-left.svg');
          mask-image: url('~@/assets/icons2026/chevron-left.svg');
}

.v2026-mt-page--next .v2026-mt-page__ico {
  -webkit-mask-image: url('~@/assets/icons2026/chevron-right.svg');
          mask-image: url('~@/assets/icons2026/chevron-right.svg');
}

.v2026-mt-ellipsis {
  min-width: 24px;
  text-align: center;
  color: #66696C;
}

.v2026-mt-preview {
  background: #ffffff;

  img {
    display: block;
    width: 100%;
    height: auto;
    max-height: 86vh;
    object-fit: contain;
  }
}
</style>
